query GetContacts(
  $page: Int
  $limit: Int
  $stringFilters: [ContactStringFilterInput!]
  $sortBy: String
) {
  contacts(
    page: $page
    limit: $limit
    stringFilters: $stringFilters
    sortBy: $sortBy
  ) {
    collection {
      id
      name
      salesforceId
      email
      contactType {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
